import './EngineMobile.scss';
import { motion } from 'framer-motion';

import EngineImg from '../../../../../assets/icons/close.svg';
import CloseIcon from '../../../../../assets/icons/close.svg';
import React from 'react';
import Carousel from '../Carousel/CarModelEngineCarousel';

import Marks from '../Marks/CarModelEngineMarks';
import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function Mobile({ data, swiperRef, onClickMark, onClose, setSlideIndex }) {
  const isOpen = data.marks.some((el) => el.open);
  return (
    <div className={'car-model-engine-mobile'}>
      <div className={'wrapper'} data-aos="fade-up">
        <div className={'top'}>
          <div className={'top_image'}>
            <Image field={data?.mobileImage} alt={'img'} />
          </div>
          <Marks data={data} onClickMark={onClickMark} />
          <motion.button
            className={'top_close'}
            onClick={onClose}
            initial={{ visibility: 'hidden', opacity: 0 }}
            animate={{ visibility: isOpen ? 'visible' : 'hidden', opacity: isOpen ? 1 : 0 }}
            transition={{ duration: 0.7, ease: 'easeInOut' }}
          >
            <img src={CloseIcon} alt={'x'} />
          </motion.button>
        </div>
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{
            height: isOpen ? '345px' : '0',
            opacity: isOpen ? 1 : 0,
          }}
          transition={{ duration: 0.7, ease: 'easeInOut' }}
          style={{ overflow: 'hidden' }}
        >
          <Carousel marks={data.marks} swiperRef={swiperRef} setSlideIndex={setSlideIndex} />
        </motion.div>
      </div>
    </div>
  );
}
